import { request } from "@/interface/helper";

const str = "communityIssue";

export const communityIssue = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/community/issue/list" }),
    add: data => request({ data, method: "post", url: "/community/issue/add" }),
    detail: data => request({ data, method: "post", url: "/community/issue/detail" }),
    edit: data => request({ data, method: "post", url: "/community/issue/modify" })
  }
};
